<nav class="nav-breadcrumbs">
  <ul class="list-breadcrumbs">
    <li *ngFor="let breadcrumb of breadcrumbs" class="list-breadcrumbs__item">
      <a
        class="list-breadcrumbs__link"
        [routerLink]="breadcrumb.url"
        title="Dashboard"
        routerLinkActive="list-breadcrumbs__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        >{{ breadcrumb.label }}</a
      >
    </li>
  </ul>
</nav>
